'use client'

import * as React from 'react'
import { motion } from 'motion/react'

import cn from '@config/tailwind/cn'

export function AnimationBorderCard({
  children,
  className,
  containerClassName,
  animate = true,
}: {
  children?: React.ReactNode
  className?: string
  containerClassName?: string
  animate?: boolean
}) {
  const variants = {
    initial: {
      backgroundPosition: '0 50%',
    },
    animate: {
      backgroundPosition: ['0, 50%', '100% 50%', '0 50%'],
    },
  }
  return (
    <div className={cn('ui:relative ui:p-[4px] ui:group', containerClassName)}>
      <motion.div
        variants={animate ? variants : {}}
        initial={animate ? 'initial' : false}
        animate={animate ? 'animate' : false}
        transition={
          animate
            ? {
                duration: 5,
                repeat: Infinity,
                repeatType: 'reverse',
              }
            : {}
        }
        style={{
          backgroundSize: animate ? '400% 400%' : undefined,
        }}
        className={cn(
          'ui:absolute ui:inset-0 ui:rounded-3xl ui:z-1 ui:opacity-60 ui:group-hover:opacity-100 ui:blur-xl ui:transition ui:duration-500',
          'ui:bg-[radial-gradient(circle_farthest-side_at_0_100%,#2D85DE,transparent),radial-gradient(circle_farthest-side_at_100%_0,#EAF3FC,transparent),radial-gradient(circle_farthest-side_at_100%_100%,#ffc414,transparent),radial-gradient(circle_farthest-side_at_0_0,#1ca0fb,#141316)]',
        )}
      />
      <motion.div
        variants={animate ? variants : {}}
        initial={animate ? 'initial' : false}
        animate={animate ? 'animate' : false}
        transition={
          animate
            ? {
                duration: 5,
                repeat: Infinity,
                repeatType: 'reverse',
              }
            : {}
        }
        style={{
          backgroundSize: animate ? '400% 400%' : undefined,
        }}
        className={cn(
          'ui:absolute ui:inset-0 ui:rounded-3xl ui:z-1',
          'ui:bg-[radial-gradient(circle_farthest-side_at_0_100%,#2D85DE,transparent),radial-gradient(circle_farthest-side_at_100%_0,#EAF3FC,transparent),radial-gradient(circle_farthest-side_at_100%_100%,#ffc414,transparent),radial-gradient(circle_farthest-side_at_0_0,#1ca0fb,#141316)]',
        )}
      />

      <div className={cn('ui:relative ui:z-10', className)}>{children}</div>
    </div>
  )
}
